import styled from 'styled-components'

export const Details = styled.div`
  align-content: space-between;
  display: flex;
  padding-left: ${props => (props.isHorizontal ? '12px' : '16px')};
  padding-right: ${props => (props.isHorizontal ? '12px' : '16px')};
  align-items: center;
  height: ${props => props.minHeight};
`
